<template>
    <div
        component="ProfileHeader"
        template=""
        :detail="isDetail"
        :popupvisible="getIsAnyPopupVisible"
        :disabled="isDisabled"
    >
        <visualizer name="profile" :detail="isDetail" />

        <h1 v-if="getActor">{{ getActor.meno_priezvisko }}</h1>

        <div ref="navigation" block="navigation">
            <div block="gallery">
                <image-slider :images="getActorGallery"></image-slider>
                <!-- <rating-banner :actor="getActor"></rating-banner> -->
            </div>

            <profile-buttons></profile-buttons>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProfileButtons from '@/components/Profile/ProfileButtons.vue';
import RatingBanner from '@/components/Profile/Ratings/RatingBanner.vue';

export default {
    name: 'Profile',

    components: {
        ProfileButtons,
        RatingBanner,
    },

    props: {
        isDetail: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        ...mapGetters([
            'getActor',
            'getActorGallery',
            'getIsAnyPopupVisible',
            'getUserTermsAgreed',
            'getIsSetActorAccessToken',
        ]),

        isDisabled() {
            return !this.getUserTermsAgreed && !this.getIsSetActorAccessToken;
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ProfileHeader'] {
    transition: 0.5s;
    position: relative;
    height: 100vw;
    width: 100%;
    top: 0;
    padding-top: 50px;
    z-index: 60;

    @media (min-width: 769px) {
        height: auto;
        width: 50%;
        overflow: hidden;
        margin: 0;
    }

    &[disabled] {
        filter: blur(5px);
        pointer-events: none;
    }

    h1 {
        position: relative;
        .flex-center;
        padding: 0;
        z-index: 7;
        width: 100%;
        transition: 1s;
        margin: 0 0 35px 0;

        @media (min-width: 640px) {
            margin: 0 0 45px 0;
        }

        @media (max-height: 500px) {
            margin: 0 0 10px 0;
        }

        @media @landscape and (max-height: 400px) {
            font-size: 18px;
        }
    }
}

// NA MOBILE SA NA DETAILE SKRÝVA

[component='ProfileHeader'][detail='true'] {
    @media (max-width: 768px) {
        height: 80px;
        margin: 0;
        // position: absolute;

        [component='Visualizer'] {
            height: 100%;

            canvas {
                top: -30px !important;
            }
        }

        h1 {
            top: -100px;
        }

        [block='navigation'] {
            top: 0;
            margin-top: -100%;
            opacity: 0;
            transition-delay: 0s;
        }
    }
}

// BLUR PRI POPUPE

[component='ProfileHeader'][popupvisible] {
    @media (max-width: 768px) {
        filter: blur(5px);
    }

    @media (min-width: 769px) {
        [component='buttons'] {
            filter: blur(5px);
        }
    }
}

// visualizer

[component='ProfileHeader'] [component='Visualizer'] {
    width: 100%;
    height: 70%;
    position: absolute;
    top: 0;
    left: 0;
    .gradientHomepage;
    overflow: hidden;
    transition: 0.5s;
    z-index: 2;

    @media (min-width: 769px) {
        height: 100%;
    }

    @media (min-width: 980px) and (min-height: 600px) {
        .radiusBig-l;
    }

    canvas {
        position: absolute;
        bottom: 0;
        opacity: 0.6;
        height: 200px;

        @media (min-width: 768px) {
            opacity: 0.4;

            @media (min-width: 768px) {
                .radiusBig-l;
            }
        }
    }
}

// Navigácia

[component='ProfileHeader'] [block='navigation'] {
    position: relative;
    .flex-center;
    width: 100%;
    transition: 0.5s;
    transition-delay: 0.2s;
    z-index: 3;

    [block='gallery'] {
        width: 100%;
        height: 100%;
        position: relative;
    }
}
</style>
